<template>
    <div :class="['componentContainer', { single: imageLength == 1, multiple: imageLength > 1 }]">
        <div class="image-layout d-flex justify-content-center align-content-center">
            <span v-if="loading" class="m-auto position-absolute spinner-border top-50"></span>
            <video ref="video" v-if="imageLength == 1"
                   width="300" height="236" style="min-width: 200px;"
                   :controls="isPlaying"
                   @loadeddata="onVideoLoaded"
                   >
                <source :src="imageOb.url" type="video/mp4">
                <source :src="imageOb.url" type="video/3gp">
                Your browser does not support the video tag.
            </video>
            <div v-if="!isPlaying && !loading" @click="playVideo" class="play-icon">
                <InlineSvg
                    :src="loadFile('video-play.svg')"
                />
            </div>
        </div>
    </div>
    <div class="messageContent fs-14px" v-if="imageOb.caption">{{ imageOb.caption }}</div>
</template>
<script setup>
import {computed, ref, onMounted, getCurrentInstance} from 'vue'
import { loadFile } from '@/components/utils.js'
import lozad from 'lozad'
import InlineSvg from '@/v2/components/inline-svg';

const props = defineProps({
    message: {
        type: Object,
        default: () => ({}),
        required: true,
    },
});
const isPlaying = ref(false);
const vm = getCurrentInstance();

const imageLength = computed(()=>{
    if(!props.message)
    return 0;
    // calc length image
    // return props.message.content.url;
    return 1;
})
const imageOb=computed(()=>{
    if(!props.message)
    return {
        url:null,
        caption:null
    };
    return {
        // url:`${process.env.MIX_STORAGE_URL}\\${props.message.content.image.url}`,
        url:`${props.message.content.video.url}`,
        caption:props.message.content.video.caption
    };
});

onMounted(()=>{
    const observer = lozad('.lozad', {
    rootMargin: '10px 0px',
    threshold: 0.1,
    enableAutoReload: true
});
observer.observe();
const base_url= window.location.origin;
});
// loading
const loading = ref(true);

const onVideoLoaded = () => {
    loading.value = false;
};

const playVideo = ()=> {
    isPlaying.value = true;
    vm.refs.video.play();
}
</script>

<style scoped lang="scss">
@import './styles/image.scss';
.play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
}

</style>
